export const getClipboardValue = async () => {
    try {
        const clipboardText = await navigator.clipboard.readText();
        return clipboardText
    } catch (error) {
        console.error('Erro ao ler da área de transferência:', error);
        
    }
}